"use client";

import { Separator } from "@/components/ui/separator";
export default function ManagedPlatformOverview() {
  const partners = [{
    name: "Marriott"
  }, {
    name: "Hilton"
  }, {
    name: "Hyatt"
  }, {
    name: "IHG"
  }, {
    name: "Accor"
  }, {
    name: "Radisson"
  }, {
    name: "Wyndham"
  }, {
    name: "Taj Hotels"
  }, {
    name: "Oberoi"
  }, {
    name: "ITC Hotels"
  }];
  const loop = [...partners, ...partners];
  return <section data-section-id="1670" id="managedplatformoverview" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="mx-auto max-w-[1280px] px-5 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {}
          <div className="md:col-span-3">
            <div className="md:sticky md:top-28">
              <div className="flex items-center gap-3">
                <span className="font-mono text-xs font-medium tracking-[0.18em] uppercase text-muted-foreground">
                  § 02 — Industry Leaders
                </span>
              </div>
              <div className="mt-4 flex items-center gap-2">
                <Separator className="bg-border max-w-16" />
                <span className="block size-1 rounded-lg" style={{
                backgroundColor: "var(--primary)"
              }} aria-hidden="true" />
              </div>
              <h4 className="mt-8 text-foreground font-default" style={{
              fontWeight: 540,
              fontSize: "clamp(1.125rem, 0.4vw + 1rem, 1.375rem)",
              lineHeight: 1.3,
              letterSpacing: "-0.005em"
            }}>
                Empowering global hospitality brands to optimize revenue,{" "}
                <span className="italic font-serif" style={{
                color: "var(--chart-2)"
              }}>
                  seamlessly.
                </span>
              </h4>
            </div>
          </div>

          {}
          <div className="md:col-span-9 relative">
            {}
            <div className="flex items-center gap-2 mb-10">
              <Separator className="bg-border flex-1" />
              <span className="block size-1 rounded-lg" style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true" />
            </div>

            {}
            <div className="relative w-full overflow-hidden group" style={{
            maskImage: "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
            WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)"
          }}>
              <div className="flex items-center marquee-track gap-20 whitespace-nowrap">
                {loop.map((item, i) => <div key={i} data-index={i} className="logo-item shrink-0 transition-colors duration-[240ms] ease-out" style={{
                color: "var(--chart-3)",
                opacity: 0.8
              }}>
                    <span className="font-serif" style={{
                  fontSize: "28px",
                  lineHeight: 1,
                  fontWeight: 420,
                  letterSpacing: "-0.01em",
                  display: "inline-block"
                }}>
                      {item.name}
                    </span>
                  </div>)}
              </div>
            </div>

            {}
            <div className="mt-10 flex items-center gap-3">
              <span className="block size-1 rounded-lg" style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true" />
              <span className="font-mono text-[0.6875rem] tracking-[0.12em] uppercase text-muted-foreground">
                10+ industry partners — trusted by leading hotel chains worldwide
              </span>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes flowstate-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          animation: flowstate-marquee 40s linear infinite;
          width: max-content;
        }
        .group:hover .marquee-track {
          animation-play-state: paused;
          transition: all 280ms ease-out;
        }
        .logo-item:hover {
          color: var(--foreground) !important;
          opacity: 1 !important;
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track {
            animation: none;
          }
        }
      `}</style>
    </section>;
}